import { render, staticRenderFns } from "./OverviewProgram.vue?vue&type=template&id=560fdda7&scoped=true&lang=pug&"
import script from "./OverviewProgram.vue?vue&type=script&lang=js&"
export * from "./OverviewProgram.vue?vue&type=script&lang=js&"
import style0 from "./OverviewProgram.vue?vue&type=style&index=0&id=560fdda7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560fdda7",
  null
  
)

export default component.exports